/**
 * Adds up the per-frame delays in an APNG's fcTL chunks to get its total
 * duration in milliseconds.
 *
 * Per the APNG spec, each fcTL chunk stores the frame delay as two
 * big-endian 16-bit values: delay_num then delay_den, located 20 and 22
 * bytes into the chunk DATA. Since the loop matches the 4-byte "fcTL"
 * type marker at index i, the data starts at i+4, so:
 *   delay_num = bytes i+24 (high) .. i+25 (low)
 *   delay_den = bytes i+26 (high) .. i+27 (low)
 * A delay_den of 0 is defined to mean 100 (i.e. delay_num is in 1/100 s).
 *
 * webCOA fix: upstream read a single byte at i+23 as the numerator and a
 * single byte at i+25 as the denominator -- both wrong offsets and
 * single-byte -- which produced garbage (usually far too short)
 * durations, so preanims like Lana's APNGs were cut off early and looked
 * sped up.
 * @param {data} apngFile the APNG data
 */
const calculateApngLength = (apngFile) => {
  const d = new Uint8Array(apngFile);
  let durationMs = 0;
  for (let i = 0; i < d.length - 27; i++) {
    // Find an fcTL chunk type marker (66 63 54 4C = "fcTL")
    if (
      d[i] === 0x66 &&
      d[i + 1] === 0x63 &&
      d[i + 2] === 0x54 &&
      d[i + 3] === 0x4c
    ) {
      const delayNum = (d[i + 24] << 8) | (d[i + 25] & 0xff);
      let delayDen = (d[i + 26] << 8) | (d[i + 27] & 0xff);
      if (delayDen === 0) delayDen = 100; // spec: 0 denominator means 100
      durationMs += (delayNum / delayDen) * 1000; // seconds -> ms
    }
  }
  return durationMs;
};
export default calculateApngLength;
